import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import moment from 'moment';
import styled from 'styled-components';

import { COLOR_BLACK } from '../../constants/colors';
import { fontStyles } from '../../constants/styles';


const Wrapper = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  padding: 0.5rem 0.75rem;
  background-color: ${(props) => (props.isActive ? 'rgba(0, 0, 0, 0.08)' : 'transparent')};
  color: ${COLOR_BLACK};
  border: 0;
  border-radius: 0.25rem;
  cursor: pointer;
  text-align: left;
  min-width: 8rem;
  transition: background-color 150ms ease-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.06);
  }

  &:focus-visible {
    outline: 1px solid ${COLOR_BLACK};
    outline-offset: 2px;
  }
`;

const Label = styled.span`
  ${fontStyles.uppercase}
  display: block;
  letter-spacing: 0.08em;
  opacity: 0.75;
`;

const Value = styled.span`
  ${fontStyles.bodySmall}
  display: block;
`;


const DateField = ({
  ariaExpanded, date, id, isActive, labelDefault, labelId, onClick, placeholderDefault, placeholderId,
}) => (
  <Wrapper
    aria-expanded={ariaExpanded}
    aria-haspopup="dialog"
    id={id}
    isActive={isActive}
    onClick={onClick}
    type="button"
  >
    <Label>
      <FormattedMessage defaultMessage={labelDefault} id={labelId} />
    </Label>
    <Value>
      <Choose>
        <When condition={!!date}>
          <FormattedDate day="numeric" month="short" value={moment(date).toDate()} weekday="short" />
        </When>
        <Otherwise>
          <FormattedMessage defaultMessage={placeholderDefault} id={placeholderId} />
        </Otherwise>
      </Choose>
    </Value>
  </Wrapper>
);

DateField.propTypes = {
  ariaExpanded: PropTypes.bool.isRequired,
  date: PropTypes.instanceOf(moment),
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  labelDefault: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  placeholderDefault: PropTypes.string.isRequired,
  placeholderId: PropTypes.string.isRequired,
};

DateField.defaultProps = {
  date: null,
};

export default DateField;
